module.exports = __webpack_public_path__ + "static/img/icon_carType07.c32a034.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_carType07.jpg
// module id = J0TI
// module chunks = 1